import {Component, Input, OnInit } from "@angular/core";
import { StaticContainer } from 'angular-shared-features/feature/shared-component/static-container.component';

@Component({
    selector: "document-container",
    templateUrl: "./document-container.template.html",
    styleUrls: ["./document-container.style.scss"]
})

export class DocumentContainer extends StaticContainer {
  
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/document-container/document-container.component.ts